import { gql } from '@apollo/client'

export const GET_PRODUCT_ATTRIBUTE_GROUPS = gql`
  query GET_PRODUCT_ATTRIBUTE_GROUPS(
    $searchTerm: String
    $take: Int
    $skip: Int
    $orderBy: [ProductAttributeGroupOrderByWithRelationInput!]
  ) {
    findManyProductAttributeGroup(
      where: {
        product_attribute_group_profiles: {
          some: { name: { contains: $searchTerm, mode: insensitive } }
        }
      }
      take: $take
      skip: $skip
      orderBy: $orderBy
    ) {
      id
      code
      product_attribute_group_profiles {
        id
        name
        description
        language
      }
      product_attributes {
        id
      }
      createdAt
      updatedAt
    }
    findManyProductAttributeGroupCount(
      where: {
        product_attribute_group_profiles: {
          some: { name: { contains: $searchTerm, mode: insensitive } }
        }
      }
    )
  }
`

export const GET_PRODUCT_ATTRIBUTE_GROUP = gql`
  query GetProductAttributeGroup($id: Int!) {
    findUniqueProductAttributeGroup(where: { id: $id }) {
      id
      code
      product_attribute_group_profiles {
        id
        name
        description
        language
      }
      product_attributes {
        id
      }
    }
  }
`

export const CREATE_PRODUCT_ATTRIBUTE_GROUP = gql`
  mutation CreateProductAttributeGroup(
    $data: CreateProductAttributeGroupWithProfilesInput!
  ) {
    createProductAttributeGroup(data: $data) {
      id
      code
      product_attribute_group_profiles {
        name
        description
        language
      }
    }
  }
`

export const UPDATE_PRODUCT_ATTRIBUTE_GROUP = gql`
  mutation UpdateProductAttributeGroup(
    $where: ProductAttributeGroupWhereUniqueInput!
    $data: UpdateProductAttributeGroupWithProfilesInput!
  ) {
    updateProductAttributeGroup(where: $where, data: $data) {
      id
      code
      product_attribute_group_profiles {
        id
        language
        name
        description
      }
    }
  }
`

export const DELETE_PRODUCT_ATTRIBUTE_GROUP = gql`
  mutation DeleteProductAttributeGroup(
    $where: ProductAttributeGroupWhereUniqueInput!
  ) {
    deleteOneProductAttributeGroup(where: $where) {
      id
    }
  }
`

export const DELETE_MANY_PRODUCT_ATTRIBUTE_GROUPS = gql`
  mutation DELETE_PRODUCT_ATTRIBUTE_GROUPS($ids: [Int!]!) {
    deleteManyProductAttributeGroup(where: { id: { in: $ids } }) {
      count
    }
  }
`
